import Image1 from '../images/image1.jpg';
import Image2 from '../images/image2.jpg';
import Image3 from '../images/image3.jpg';
import Image4 from '../images/image4.jpg';

export const SliderData = [
  {
    title: 'Luxury Villa in Bali, Indonesia',
    price: '$4,200.000',
    path: '1',
    label: 'View Home',
    image: Image1,
    alt: 'House',
  },
  {
    title: 'Luxury House in Paris, France',
    price: '$2,700.000',
    path: '2',
    label: 'View Home',
    image: Image2,
    alt: 'House',
  },
  {
    title: 'House in São Paulo, Brazil',
    price: '$1,700.000',
    path: '3',
    label: 'View Home',
    image: Image3,
    alt: 'House',
  },
  {
    title: 'Beautiful House in California, USA',
    price: '$8,000.000',
    path: '4',
    label: 'View Home',
    image: Image4,
    alt: 'House',
  },
];
